import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withModifiers as _withModifiers, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { useForm } from '@inertiajs/vue3';
    import DialogForm from '@/components/DialogForm.vue';
    import { useI18n } from 'vue-i18n';
    import TaskTemplateForm from './TaskTemplateForm.vue';
    import AddButton from '@/components/AddButton.vue';
    import { ref } from 'vue';
    import QueryKey from '@/enums/QueryKey';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'CreateTaskTemplate',
  setup(__props) {

    const { t } = useI18n();

    const taskTemplateForm = ref<InstanceType<typeof TaskTemplateForm>>();

    const form = useForm({
        name: '',
        description: '',
        tasks: [],
    });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(DialogForm, {
    type: "create",
    form: _unref(form),
    route: _ctx.route('v2.task-templates.store'),
    "query-key": [_unref(QueryKey).TASK_TEMPLATES],
    title: "task-templates.create",
    "button-text": "task-templates.create",
    "modal-size": "sm:max-w-3xl"
  }, {
    footerActions: _withCtx(() => [
      _createVNode(AddButton, {
        class: "mr-auto",
        onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (taskTemplateForm.value?.addTask()), ["prevent"]))
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(t)('task-templates.add_task')), 1)
        ]),
        _: 1
      })
    ]),
    default: _withCtx(() => [
      _createVNode(TaskTemplateForm, {
        ref_key: "taskTemplateForm",
        ref: taskTemplateForm,
        form: _unref(form)
      }, null, 8, ["form"])
    ]),
    _: 1
  }, 8, ["form", "route", "query-key"]))
}
}

})